/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'

import './index.css'
import { useNavigate } from 'react-router-dom'
import { rtcToText } from '../../functions/mask'
import api from '../../services/api'
import { usePluginspace } from '../../hooks/usePluginspace'
import { Loading } from '../../components/Loading'

export interface MessageModel {
  user: number
  type: 'in' | 'out'
  text: string
  time?: number
  template?: boolean
}

type Props = {
  isDrawer?: boolean
}

type LocalSavedMessageType = {
  lastMessage: Date,
  messages: MessageModel[],
  sessionId: string;
}

type UserInfoModel = {
  name: string
  avatar: string
}

type PluginconfigType = {
  id: number;
  name: string;
  content: any;
  plugintemplateId: number;
  plugintypeId: number;
}

type TemplateType = {
  id: number;
  name: string;
  image: string | null;
  parameters: string;
  plugintypeId: number;
  pluginconfig: PluginconfigType;
  typeIntegration: string;
  able: boolean | null;
}

type SendMessageType = {
  inputText?: string;
  sessionId: string;
  agentId?: string;
  agentAliasId?: string;
  prompt?: string;
  humanized?: boolean;
}

export function ChatIA() {
  const navigate = useNavigate();
  const { getToken } = usePluginspace();
  
  console.log('✨ ChatIA COMPONENT MOUNTED');


  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [agentId, setAgentId] = useState('');
  const [agentName, setAgentName] = useState('');
  const [agentAliasId, setAgentAliasId] = useState('');
  const [messages, setMessages] = useState<MessageModel[]>([{
    user: 0,
    type: 'in',
    text: 'Olá, o que você precisa?',
    time: new Date().getTime()
  }])
  const [userInfos] = useState<UserInfoModel[]>([
    {
      name: 'Ninegrid',
      avatar: 'avatars/300-6.jpg',
    },
    {
      name: 'Você',
      avatar: 'avatars/300-6.jpg',
    }
  ])

  const [loading, setLoading] = useState(false);
  const [loadingGeral, setLoadingGeral] = useState(false);
  
  const [sessionId, setSessionId] = useState('');

  const [messageLoading, setMessageLoading] = useState<MessageModel>({
    user: 0,
    type: 'in',
    text: '...',
  })

  const textbox = useRef(null);

  const sendMessage = (type: 'in' | 'out', user: number, messageReceived?: string) => {
    console.log('📨 sendMessage chamada:', { type, user, messageReceived: messageReceived || message });
    
    const newMessages = [...messages]
    const newMessage: MessageModel = {
      user: user,
      type: type,
      text: messageReceived ? messageReceived : message,
      time: new Date().getTime(),
    }
    newMessages.push(newMessage)
    setMessages(newMessages)
    toggleChatUpdate()
    
    if(type === 'out'){
      console.log('⏱️ AGENDANDO sendMessageNinegridIA com 200ms delay');
      setTimeout(() => {
        console.log('⏲️ ExecutANDO sendMessageNinegridIA agora');
        try {
          sendMessageNinegridIA(message, newMessages)
        } catch (e) {
          console.error('❌ Erro ao chamar sendMessageNinegridIA:', e);
        }
      }, 200);
      
      setMessage('')
    }
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      if(message) sendMessage('out', 1)
    }
  }

  const getTimeDifference = (timeMessage: number) => {
    const dateMsg = new Date(timeMessage);
    const today = new Date()
    const timeNow = today.getTime();
    const timeMinutes = Math.trunc((timeNow - timeMessage)/60000)
    return  timeMinutes <= 0 ? 
              'Enviado agora' : 
              today.toLocaleDateString() === dateMsg.toLocaleDateString() ? 
                dateMsg.toLocaleTimeString().substring(0, 5) : 
                `${dateMsg.toLocaleDateString()} ${dateMsg.toLocaleTimeString().substring(0, 5)}`
  }

  const animateMessageLoading = () => {
    const now = new Date().getTime() / 300;
    switch(Math.trunc(now % 3)) {
      case 0:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '.'
        });
        break;
      case 1:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '..'
        });
        break;
      case 2:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '...'
        });
        break;
      default:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '...'
        });
        break;
    }
  }

  const sendMessageNinegridIA = async (messageToSend: string, newMessages: MessageModel[]) => {
    try {
      console.log('🚀 ENVIANDO MENSAGEM PARA API - Prompt:', messageToSend);
      setLoading(true);

      const response = await api.post(
        `/classification-ia/classify`,
        { prompt: messageToSend },
        { headers: { Authorization: `Bearer ${await getToken()}` } }
      );

      console.log('✅ RESPOSTA RECEBIDA:', response?.data);
      const result = response?.data;
      setLoading(false);

      let messageIA = '';
      let newSessionId = sessionId;

      if (result?.data?.target === 'Greeting') {
        messageIA = result.data?.greetingResponse || 'Olá!';
        console.log('🎉 SAUDAÇÃO DETECTADA:', messageIA);
      } else {
        messageIA = 'Resposta processada';
      }

      console.log('📝 ADICIONANDO MENSAGEM AO CHAT:', messageIA);
      const newMessage: MessageModel = {
        user: 0,
        type: 'in',
        text: messageIA,
        time: new Date().getTime(),
      };
      newMessages.push(newMessage);
      console.log('📌 ATUALIZANDO STATE COM', newMessages.length, 'mensagens');
      setMessages(newMessages);

      saveLocalMessages(newMessages, newSessionId);
      toggleChatUpdate();
      scrollToBottm();
    } catch (error: any) {
      console.error('❌ ERRO NA API:', error?.message || error);
      setLoading(false);
      const newMessage: MessageModel = {
        user: 0,
        type: 'in',
        text: 'Erro: ' + (error?.message || 'Unknown'),
        time: new Date().getTime(),
      };
      newMessages.push(newMessage);
      setMessages(newMessages);
      saveLocalMessages(newMessages, sessionId);
      toggleChatUpdate();
    }
  }

  const toggleChatUpdate = () => {
    toggleChatUpdateFlat(!chatUpdateFlag)
    setTimeout(() => {
      toggleChatUpdateFlat((flag) => !flag)
    }, 1000)
  }

  const saveLocalMessages = (newMessages: MessageModel[], newSessionId: string) => {
    localStorage.setItem(window.btoa('messagesIA'), window.btoa(JSON.stringify({
      lastMessage: new Date(),
      messages: newMessages,
      sessionId: newSessionId
    })))
  }

  const adjustHeightTextArea = () => {
    if(textbox && textbox.current){
      const styleTextbox:any = textbox.current
      if(styleTextbox.scrollHeight <= 145){
        styleTextbox.style.height = "inherit";
        styleTextbox.style.height = `${styleTextbox.scrollHeight}px`;
        const divChat = document.getElementById('chat-body');
        const divFooter = document.getElementById('kt_drawer_chat_messenger_footer');
        if(divChat && divFooter){
          divFooter.style.height = `calc(${110 + (styleTextbox.scrollHeight - 64)}px - 2em)`
          divChat.style.height = `calc(100vh - 110px - 2em - 60px - ${(styleTextbox.scrollHeight - 64)}px)`
        }
      }
    }
  }

  const scrollToBottm = () => {
    const divChat = document.getElementById('chat-scroll')
    if(divChat){
      divChat.scrollTo(0, divChat.scrollHeight)
    }
  }

  const verifyAgent = async () => {
    setLoadingGeral(true)
    const templateRes = await api
      .get(
        `/api/plugintemplate/ia`,
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => response.data)
      .catch((e) => e)
    
    let modelId = ''
    let agentName = ''
    if(templateRes && templateRes.data){
      templateRes.data.forEach((template: TemplateType) => {
        if(template.pluginconfig && template.pluginconfig.content && template.pluginconfig.content.able){
          modelId = template.pluginconfig.content.modelId
          agentName = template.pluginconfig.content.agentName
        }
      })
    }
    if(modelId && agentName){
      const agentItems = await api
        .get(
          `/api/agent-ia/listAgentNIS/${agentName}`,
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => response.data)
        .catch((e) => e)
      if(agentItems.agentId) setAgentId(agentItems.agentId)
      if(agentItems.agentAliasId) setAgentAliasId(agentItems.agentAliasId)
      if(agentItems.agentName) setAgentName(agentItems.agentName.split("-")[0])
    }
    setLoadingGeral(false)
  }

  useEffect(() => {
    verifyAgent();
    const messagesIALocal = localStorage.getItem(window.btoa('messagesIA'))
    
    if(messagesIALocal){
      const messageLocalSaved:LocalSavedMessageType = JSON.parse(window.atob(messagesIALocal));
      if(
        messageLocalSaved && 
        messageLocalSaved.lastMessage && 
        messageLocalSaved.messages && 
        messageLocalSaved.sessionId
      ){
        if((new Date().getTime() - new Date(messageLocalSaved.lastMessage).getTime()) < (1000 * 60 * 60 * 24)){
          setMessages(messageLocalSaved.messages)
          setSessionId(messageLocalSaved.sessionId)
        } else {
          localStorage.removeItem(window.btoa('messagesIA'))
        }
      }
    }
    setInterval(() => {
      animateMessageLoading()
    }, 300)
  }, [])

  useEffect(() => {
    scrollToBottm()
  },[messages])

  return (
    <div
      id='kt_drawer_chat'
      className='chat-ia'
      style={{boxShadow: '0px 0px 40px -3px rgba(0, 0, 0,0.2)'}}
    >
      <div className='content-chat-ia' id='kt_drawer_chat_messenger'>
        {loadingGeral ? (
					<div style={{width: '100%', height: 'calc(100vh)'}}>
						<Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
					</div>
				) : (
          <>
            <div className='header-chat-ia' id='kt_drawer_chat_messenger_header'>
              <div className='title'>
                <div className='title-content'>
                  <a href=''>
                    {agentName}
                  </a>

                  <div className='badge-title'>
                    <span className='badge'></span>
                    <span className='text'>Online</span>
                  </div>
                </div>
              </div>

              <div className='btn' style={{cursor: 'pointer'}} onClick={() => navigate(-1)}>
                <i className='fa fa-times fs-3'></i>
              </div>
            </div>
            <div
              className='chat-body'
              id='chat-body'
            >
              <div
                id='chat-scroll'
                className='chat-inner'
              >
                {
                  [...messages, loading ? messageLoading : null].map((message, index) => {
                    if(message){
                      const userInfo = userInfos[message.user]
                      const state = message.type === 'in' ? 'info' : 'primary'
                      const templateAttr = {}
                      if (message.template) {
                        Object.defineProperty(templateAttr, 'data-kt-element', {
                          value: `template-${message.type}`,
                        })
                      }
                      
                      return (
                        <div
                          key={`message${index}`}
                          className={`message message-${message.type}`}
                          {...templateAttr}
                        >
                          <div className='title'>
                            {message.type === 'in' ? (
                              <>
                                <div className='title-content'>
                                  <a
                                    href='#'
                                  >
                                    {userInfo.name}
                                  </a>
                                  <span>{message.time ? getTimeDifference(message.time) : ''}</span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className='title-content'>
                                  <span>{message.time ? getTimeDifference(message.time) : ''}</span>
                                  <a
                                    href='#'
                                  >
                                    Você
                                  </a>
                                </div>
                              </>
                            )}
                          </div>

                          <div
                            className='message-text'
                            data-kt-element='message-text'
                            dangerouslySetInnerHTML={{__html: rtcToText(message.text)}}
                          ></div>
                        </div>
                      )
                    }
                  })}
              </div>
            </div>
            <div
              className='footer-chat'
              id='kt_drawer_chat_messenger_footer'
            >
              <div className='footer-chat-content'>
                <textarea
                  ref={textbox}
                  style={{resize: 'none'}}
                  className='chat-text'
                  placeholder='Envie uma mensagem...'
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value)
                    adjustHeightTextArea();
                  }}
                  onKeyDown={onEnterPress}
                ></textarea>
                <button
                  style={{padding: '0.75em 1.5em'}}
                  className='btn btn-primary'
                  type='button'
                  data-kt-element='send'
                  onClick={() => {if(message) sendMessage('out', 1)}}
                >
                  Enviar
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    
  )
}
